import React, { useMemo } from 'react';
import { PageTabs } from '@colonist/ui-platform';
import IconProfileOverview from '@static/images/icon_profile_overview.svg';
import IconProfileRanked from '@static/images/icon_profile_ranked.svg';
import IconProfileHistory from '@static/images/icon_profile_history.svg';
import IconProfileItems from '@static/images/icon_profile_items.svg';
import IconProfileFriends from '@static/images/icon_profile_friends.svg';
import IconSettings from '@static/images/icon_settings.svg';
import { useLegacyPageTabsLayout } from './useLegacyPageTabsLayout.ts';
export var ProfilePageTabId = /*#__PURE__*/ function(ProfilePageTabId) {
    ProfilePageTabId["Overview"] = "overview";
    ProfilePageTabId["Ranked"] = "ranked";
    ProfilePageTabId["History"] = "history";
    ProfilePageTabId["Items"] = "items";
    ProfilePageTabId["Friends"] = "friends";
    ProfilePageTabId["Settings"] = "settings";
    return ProfilePageTabId;
}({});
const DEFAULT_LEGACY_DIRECTION = 'vertical';
const allProfileTabDefs = [
    {
        id: "overview",
        labelKey: 'strings:profilePage.overview.title',
        icon: IconProfileOverview
    },
    {
        id: "ranked",
        labelKey: 'strings:profilePage.navigationTabs.ranked',
        icon: IconProfileRanked
    },
    {
        id: "history",
        labelKey: 'strings:profilePage.navigationTabs.history',
        icon: IconProfileHistory
    },
    {
        id: "items",
        labelKey: 'strings:profilePage.navigationTabs.items',
        icon: IconProfileItems
    },
    {
        id: "friends",
        labelKey: 'strings:profilePage.navigationTabs.friends',
        icon: IconProfileFriends
    },
    {
        id: "settings",
        labelKey: 'strings:profilePage.navigationTabs.account',
        icon: IconSettings
    }
];
const useProfileTabs = (showFriends, showSettings)=>useMemo(()=>{
        return allProfileTabDefs.filter((tab)=>{
            if (tab.id == "friends") return showFriends;
            if (tab.id == "settings") return showSettings;
            return true;
        }).map((tab)=>({
                id: tab.id,
                label: {
                    key: tab.labelKey
                },
                icon: tab.icon
            }));
    }, [
        showFriends,
        showSettings
    ]);
// TODO(ENG-337): remove once the legacy EJS profile is replaced.
const ProfilePageTabsContainerLegacy = ({ activeTabId, onTabChange, showFriends, showSettings, direction: baseDirection = DEFAULT_LEGACY_DIRECTION })=>{
    const tabs = useProfileTabs(showFriends, showSettings);
    const { direction, hideText } = useLegacyPageTabsLayout(baseDirection);
    return /*#__PURE__*/ React.createElement(PageTabs, {
        activeTabId: activeTabId,
        tabs: tabs,
        onTabChange: (tabId)=>onTabChange(tabId),
        direction: direction,
        hideText: hideText
    });
};
const ProfilePageTabsContainerControlled = ({ activeTabId, onTabChange, showFriends, showSettings, direction, hideText })=>{
    const tabs = useProfileTabs(showFriends, showSettings);
    return /*#__PURE__*/ React.createElement(PageTabs, {
        activeTabId: activeTabId,
        tabs: tabs,
        onTabChange: (tabId)=>onTabChange(tabId),
        direction: direction,
        hideText: hideText
    });
};
export const ProfilePageTabsContainer = (props)=>{
    if (props.layoutMode == 'controlled') return /*#__PURE__*/ React.createElement(ProfilePageTabsContainerControlled, props);
    return /*#__PURE__*/ React.createElement(ProfilePageTabsContainerLegacy, props);
};
